<template>
	<div :style="style" class="journey__stop-icon">
		<component :is="iconComponent"/>
	</div>
</template>

<script>
import AirportBorderIcon from "@/assets/flyt-icons_airport--border.svg?inline"
import HelipadBorderIcon from "@/assets/flyt-icons_heliport--border.svg?inline"
import { mapGetters } from "vuex"

export default {
	name: 'FlytJourneyLocationIcon',

	props: {
		color: {
			type: String,
			default: '#5bc1b8'
		}
	},

	computed: {
		...mapGetters("bookingForm", ["aircraftCategory"]),

		style () {
			return `color: ${this.color}`
		},

		/**
		 * Journey icon based on current aircraft category type
		 */
		iconComponent() {
			let icon
			switch (this.aircraftCategory) {
				case 'aeroplane':
					icon = AirportBorderIcon
					break;
				case 'helicopter':
					icon = HelipadBorderIcon
					break;
			}
			return icon
		},
	}
}
</script>

<style lang="scss" scoped>
/deep/ svg {
	fill: currentColor;
}
</style>